import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAC3uXQmxl2BINHQ8ls-JVgCg8QTkOrM_4",
  authDomain: "shirdhankar-technologies.firebaseapp.com",
  projectId: "shirdhankar-technologies",
  storageBucket: "shirdhankar-technologies.firebasestorage.app",
  messagingSenderId: "792966524254",
  appId: "1:792966524254:web:ac4e637ccd2e00f870b3cf",
  measurementId: "G-J70J2KCT46"
};

const app = initializeApp(firebaseConfig);

//const analytics = getAnalytics(app);

export const db = getFirestore(app);

export const storage = getStorage(app);

export default app;